<section class="content tab-section d-flex flex-column" >
    <div class="content-block flex-grow-1 d-flex flex-column">
      <div class="flex-grow-1 d-flex">
        <app-course-dashboard [isCourseBuilder]="false"></app-course-dashboard>
      </div>
   
    </div>
  </section>
